import { render, staticRenderFns } from "./EnacCustomAtplPhaseEditForm.vue?vue&type=template&id=18c64bd2"
import script from "./EnacCustomAtplPhaseEditForm.vue?vue&type=script&lang=js"
export * from "./EnacCustomAtplPhaseEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports